import { Config } from "./config";

export const ssoAuthAPI = async ({ token }) => {
  try {
    const response = await fetch(`${Config.env.app.sso_api_url}/profile/me`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => res.json());

    if (response.status === true) {
      return response.data.data;
    } else {
      localStorage.removeItem("return_token");
      const params = new URLSearchParams(window.location.search);
      params.delete("return_token");
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${params.toString()}`
      );
    }
  } catch (error) {
    localStorage.removeItem("return_token");
    const params = new URLSearchParams(window.location.search);
    params.delete("return_token");
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${params.toString()}`
    );
    console.log("error", error);
  }
};

export const ssoAddressAPI = async ({ token }) => {
  try {
    const response = await fetch(
      `${Config.env.app.sso_api_url}/profile/address`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    ).then((res) => res.json());
    if (response.status === true) {
      return response.data;
    }
  } catch (error) {
    localStorage.removeItem("return_token");
    const params = new URLSearchParams(window.location.search);
    params.delete("return_token");
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${params.toString()}`
    );
    console.log("error", error);
  }
};

export const ssoDeleteAddressAPI = async ({ addressId, token }) => {
  try {
    const response = await fetch(
      `${Config.env.app.sso_api_url}/profile/address/${addressId}/delete`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    ).then((res) => res.json());
    if (response.status === true) {
      return response.message;
    }
  } catch (error) {
    localStorage.removeItem("return_token");
    const params = new URLSearchParams(window.location.search);
    params.delete("return_token");
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${params.toString()}`
    );
    console.log("error", error);
  }
};
